__turbopack_context__.v({
  "block": "_rZ6iG_block",
  "block2": "_rZ6iG_block2",
  "caseStudyBanner": "_rZ6iG_caseStudyBanner",
  "caseStudyBannertype_meharry": "_rZ6iG_caseStudyBannertype_meharry",
  "caseStudyBannertype_uconn": "_rZ6iG_caseStudyBannertype_uconn",
  "caseStudyBannertype_usc": "_rZ6iG_caseStudyBannertype_usc",
  "desc": "_rZ6iG_desc",
  "desc2": "_rZ6iG_desc2",
  "desktop": "_rZ6iG_desktop",
  "img": "_rZ6iG_img",
  "imgtype_meharry": "_rZ6iG_imgtype_meharry",
  "imgtype_uconn": "_rZ6iG_imgtype_uconn",
  "quoteLogo": "_rZ6iG_quoteLogo",
  "stats": "_rZ6iG_stats",
  "title2": "_rZ6iG_title2",
  "titleContainer": "_rZ6iG_titleContainer",
  "top2": "_rZ6iG_top2",
  "val": "_rZ6iG_val",
  "val2": "_rZ6iG_val2",
});
